import { Space, Tag } from "antd";
import { useIntl } from "react-intl";
import PersonListImage from "../PersonListImage";

type Props = {
  person?: any;
  checkIfAlreadyAdded?: (person: any) => boolean;
  onImageClick?: (person: any) => void;
};

export const PersonLabel = ({ person, checkIfAlreadyAdded, onImageClick }: Props) => {
  const { formatMessage } = useIntl();
  if (!person?.nameFullLocal) {
    return;
  }

  return (
    <Space>
      <PersonListImage person={person} onImageClick={onImageClick} />
      {person.nameFullLocal}
      {checkIfAlreadyAdded?.(person) && (
        <Tag className="ml-5 text-upper" color="default">
          {formatMessage({ id: "alreadyAdded" })}
        </Tag>
      )}
      {person.personId && (
        <Tag className="ml-5 text-upper" color="geekblue">
          {formatMessage({ id: "newlyCreated" })}
        </Tag>
      )}
    </Space>
  );
};
